<template>
  <div class="ai-assistent">
    <div class="ai-tool" @click="openDialog">
      <img src="@/assets/img/robot.gif" width="100px"/>
    </div>
    <AiAssistentDialog title="Mitai AI助理" v-model="visible" @close="close">
      <div slot="content">
        <AiAssistentChat :chatOriginalList="chatOriginalList" v-if="visible"></AiAssistentChat>
      </div>
      <div slot="footer" class="bottom">
        <div class="input-box" :class="[disabled && 'disabled']">
          <el-input ref="elInput" type="textarea" resize="none" placeholder="请输入" :disabled="disabled" v-model="value">
          </el-input>
          <i class="el-icon-position btm-icon" :class="[valueSend && 'is-can-send']" @click="send"></i>
        </div>
      </div>
    </AiAssistentDialog>
  </div>
</template>

<script>
import AiAssistentDialog from './aiAssistentDialog.vue';
import AiAssistentChat from './aiAssistentChat.vue';
import { strTrim, getUuid } from '@/utils/base.js';
import bus from '@/utils/eventBus.js';
export default {
  name: 'AiAssistent',
  components: { AiAssistentDialog, AiAssistentChat },
  data() {
    return {
      visible: false,
      value: '',
      disabled: false,
      answer: '',
      conversationId: '',
      chatOriginalList: [],
      // eventSource 接口
      eventSource: null,
    }
  },
  computed: {
    // 发送按钮是否生效
    valueSend() {
      return strTrim(this.value)
    },
  },
  methods: {
    // 发送消息
    send() {
      if (!this.valueSend) {
        return
      }
      const query = this.valueSend
      const conversationId = this.conversationId
      this.connectEventSource2(query, conversationId)
      bus.$emit('scrollToBottom')
    },
    // 流式处理 -- fetch请求
    connectEventSource(query, conversationId) {
      let _this = this;
      _this.value = ''
      _this.disabled = true
      _this.setChatValue(query)
      _this.setChatOriginalListLastItem(true)
      fetch('/index.php' + `/shop/llmchat.llmChat/chatMessage2?query=${query}&conversation_id=${conversationId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {}, //请求参数
      }).then(response => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        function processStreamResult(result) {
          const chunk = decoder.decode(result.value, { stream: !result.done });
          buffer += chunk;
          //逐条解析后端返回数据
          const lines = buffer.split('\n');
          // console.log(lines, '-');
          buffer = lines.pop();

          lines.forEach(line => {
            if (line.trim().length > 0) {
              //后端返回数据格式：data:{a:'x'};不知道为什么会多出data:，处理一下
              const jsonData = line.substring(line.indexOf('{'));
              if (jsonData === 'event: ping') {
                return
              }
              const eventData = JSON.parse(jsonData);
              // console.log(eventData, ' -- ');

              if (eventData.event === 'message') {
                _this.conversationId = eventData.conversation_id
                _this.answer += eventData.answer
                _this.setChatOriginalListLastItem()

              } else if (eventData.event === 'message_end') {
                _this.$nextTick(() => {
                  _this.setFocus()
                })
                _this.answer = ''
                _this.disabled = false
              }
            }
          });

          if (!result.done) {
            return reader.read().then(processStreamResult);
          }
        }
        return reader.read().then(processStreamResult);
      }).catch(error => {
        console.error('Error:', error);
        _this.answer = ''
        _this.disabled = false
      });
    },
    // 流式处理 -- EventSource请求
    connectEventSource2(query, conversationId) {
      this.value = ''
      this.disabled = true
      this.setChatValue(query)
      this.setChatOriginalListLastItem(true)

      // utf-8解析
      // const decoder = new TextDecoder('utf-8');

      // SSE的URL
      const sseUrl = '/index.php' + `/shop/llmchat.llmChat/chatMessage2?query=${query}&conversation_id=${conversationId}`;
      // 创建EventSource实例
      this.eventSource = new EventSource(sseUrl);
      // 监听信息
      this.eventSource.onmessage = (event) => {
        const eventData = JSON.parse(event.data || '{}');
        // console.log(eventData,' --');
        if (eventData.event === 'message') {
          this.conversationId = eventData.conversation_id
          this.answer += eventData.answer;
          this.setChatOriginalListLastItem()

        } else if (eventData.event === 'message_end') {
          this.$nextTick(() => {
            this.setFocus()
          })
          this.answer = ''
          this.disabled = false
          if (this.eventSource) {
            this.eventSource.close()
            this.eventSource = null
          }
        }
      }
    },
    // 处理数据：接口返回数据
    setChatOriginalListLastItem(isLoading = false) {
      const index = this.chatOriginalList.length - 1
      if (isLoading) {
        this.chatOriginalList.push({
          type: '1',
          id: getUuid(),
          content: '',
          status: '0',
          statusText: '我正在理解',
        })
      } else {
        const id = this.chatOriginalList[index]['id']
        this.chatOriginalList.splice(index, 1, {
          type: '1',
          id: id,
          content: this.answer,
          isNoWater: true,
          status: '',
          statusText: ''
        })
        bus.$emit('scrollToBottom')
      }
    },
    // 用户提问数据
    setChatValue(query) {
      this.chatOriginalList.push({
        type: '2',
        id: getUuid(),
        content: query,
      })
    },
    // focus 聚焦
    setFocus() {
      this.$refs.elInput.focus()
    },
    // 打开
    openDialog() {
      this.visible = true
      this.chatOriginalList = [{
        type: '1',
        id: getUuid(),
        content: '欢迎回来，那就开始你的提问吧，有什么需要我解答的吗？'
      }]
    },
    // 关闭
    close() {
      this.value = ''
      this.conversationId = ''
      this.chatOriginalList = []

    },
  }
}
</script>
<style lang="scss" scoped>
.ai-assistent {
  position: fixed;
  right: 10px;
  bottom: 100px;
  z-index: 88;

  .ai-tool {
    //padding: 8px 22px;
    //border-radius: 16px;
    //background: #fff;
    //box-sizing: border-box;
    //box-shadow: 1px 1px 12px #d6e7f3;
    cursor: pointer;
    //font-size: 13px;
  }

  .bottom {
    margin-top: 6px;

    .input-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #dedede;
      border-radius: 4px;

      &.disabled {
        background: #F5F7FA;
      }

      /deep/ .el-textarea__inner {
        border: unset;
        border-color: unset;
        padding: 5px 8px;
        font-size: 13px;
      }

      .btm-icon {
        margin-left: 6px;
        margin-right: 6px;
        font-size: 20px;
        color: #333;
        cursor: pointer;

        &.is-can-send {
          color: #53dcdc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/aiAssistent/aiAssistent.vue